import React from "react";
import { useEffect } from "react";
import { getFromLocalStorage } from "../../../utils/webStorage";
import userService from "../../../services/user.service";
import { useState } from "react";
import UserProfile from "../../../Common/UserProfile";

const AthleteProfileDetails = () => {
  const [schoolData, setSchoolData] = useState({});
  const [groupAthletes, setGroupAthletes] = useState([]);
  const [activeSports, setActiveSports] = useState([]);
  const [loading, setLoading] = useState(false);
  const athleteId = getFromLocalStorage("athleteId");

  useEffect(() => {
    setLoading(true);
    userService
      .getAthleteDetails(athleteId)
      .then((response) => {
        const data = response.data.data;
        setActiveSports(data.assignedSports.map((item) => item.id));
        setSchoolData(data);
        setGroupAthletes(data.groupAthletes);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("There was an error!", error);
      });
  }, []);

  return (
    <div>
      <UserProfile
        schoolData={schoolData}
        groupAthletes={groupAthletes}
        activeSports={activeSports}
        flag="athlete"
        URL="/editathleteprofile"
        loading={loading}
      />
    </div>
  );
};

export default AthleteProfileDetails;
